import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface LegalForm {
  id: string;
  code: string;
  name: string;
  country_code: string;
  description: string | null;
}

export function useLegalForms(countryCode?: string | null) {
  return useQuery({
    queryKey: ['legal-forms', countryCode ?? 'all'],
    queryFn: async () => {
      let query = supabase
        .from('legal_forms')
        .select('id, code, name, country_code, description')
        .order('name');

      if (countryCode) {
        query = query.eq('country_code', countryCode);
      }

      const { data, error } = await query;
      if (error) throw error;
      return (data ?? []) as LegalForm[];
    },
    staleTime: 1000 * 60 * 60, // 1hr — legal forms rarely change
  });
}
